import { tokens } from '@/theme'
import { MOBILE_MAX } from '@/components/layout/responsive'
import type { SettingsSection } from '@/views/SettingsView'

/**
 * Values SettingsView and its skeleton both draw with, so the skeleton lands
 * on the same labels and row metrics as the loaded page.
 */

/** The sidebar folds over the panel at phone width. */
export const settingsGridStyles = `
@media (max-width: ${MOBILE_MAX}px) {
  .keystone-settings-grid { grid-template-columns: minmax(0, 1fr) !important; gap: 24px !important; }
  .keystone-settings-grid > aside { position: static !important; }
}
`

/** The caller's own sections, in sidebar order. The view hides approval from non-managers. */
export const SETTINGS_SECTIONS: { id: Exclude<SettingsSection, 'admin'>; label: string }[] = [
  { id: 'general', label: 'General' },
  { id: 'working-time', label: 'Working time' },
  { id: 'country', label: 'Country' },
  { id: 'approval', label: 'Absence approval' },
  { id: 'help', label: 'Help' },
]

/** Each own section's title and lede, for the view and its skeleton. */
export const SETTINGS_HEADS = {
  general: { title: 'General', lede: 'Applies to you only.' },
  'working-time': {
    title: 'Working time',
    lede: 'Your usual week. An empty field uses the default shown in it.',
  },
  country: {
    title: 'Country',
    lede: 'Your home country and region. They drive the public-holiday row on your weeks.',
  },
  // Its lede is MODES, drawn as a list by both.
  approval: { title: 'Absence approval' },
  help: { title: 'Help', lede: 'Videos that show how Keystone works.' },
} as const

/** One ruled row of a settings form. */
export const row = {
  padding: '12px 0',
  borderBottom: `1px solid ${tokens.line}`,
  fontSize: 14,
  color: tokens.ink,
} as const

/** Monday first, as every calendar in the app is. The wire counts from 0 = Sunday. */
export const DAYS: { n: number; label: string }[] = [
  { n: 1, label: 'Mon' },
  { n: 2, label: 'Tue' },
  { n: 3, label: 'Wed' },
  { n: 4, label: 'Thu' },
  { n: 5, label: 'Fri' },
  { n: 6, label: 'Sat' },
  { n: 0, label: 'Sun' },
]

/** The two ways a Manager's reports' time-off requests can be handled. */
export const MODES: { value: 'manual' | 'auto'; label: string; explains: string }[] = [
  {
    value: 'manual',
    label: 'Manual approve',
    explains: 'Requests go to Approvals. You approve or reject, and the requester is notified.',
  },
  {
    value: 'auto',
    label: 'Auto approve and notify',
    explains: 'Requests are approved at once. You get a notification only.',
  },
]
